import { darken } from 'polished';

export default {
  primary: '#426871',
  secondary: '#ffe69b',

  primaryHover: darken(0.1, '#426871'),
  secondaryHover: darken(0.1, '#ffe69b'),
};
